<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" size="mini" :model="pages" class="filter-panel fl">
				<el-form-item>
					<el-date-picker v-model="pages.date" value-format="yyyy-MM" type="monthrange" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.starttime')" :end-placeholder="$t('course_index.endtime')"></el-date-picker>
				</el-form-item>
				<el-form-item >{{$t('sharing.实收')}}：{{amount}}{{$t('sharing.元')}}</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" @click="sousuo">{{$t('index.query')}}</el-button>
					<el-button type="" size="mini" @click="chongxzhi">{{$t('index.reset')}}</el-button>
				</el-form-item>
			</el-form>
			<div class="list-opinion fr">
				<el-button type="primary" size="mini" @click="add()" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
			</div>
		</div>
		<el-table :data="list" border size="mini">
			<el-table-column prop="company" align="center" :label="$t('sharing.公司名称')"></el-table-column>
			<el-table-column prop="account" align="center" :label="$t('sharing.分账账号')"></el-table-column>
			<!-- <el-table-column prop="rate" align="center" :label="$t('sharing.分账比例')"></el-table-column> -->
			<el-table-column prop="enable" align="center" :label="$t('sharing.是否启用')">
				<template slot-scope="{row}">
					<el-switch v-model="row.enable" @change="enable_change(row)" :active-value="1" :inactive-value="0"></el-switch>
				</template>
			</el-table-column>
			<el-table-column prop="enable_time" align="center" :label="$t('sharing.最新启用时间')">
				<template slot-scope="{row}">{{getTime_us(row.enable_time,'mmddyyyy')}} {{getTime_us(row.enable_time,'hh:ii')}}</template>
			</el-table-column>
			<el-table-column :label="$t('index.operation')" align="center"  fixed="right" width="260">
				<template slot-scope="{row}">
					<el-button size="mini" type="primary" v-if="hasBtn('edit')" @click="add(row)">{{$t('index.edit')}}</el-button>
					<el-button size="mini" type="danger" v-if="hasBtn('del')" @click="del(row)">{{$t('index.del')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog :title="$t('index.dialog_title')" width="800px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
			<el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm">
				<el-row class="tree-content" :gutter="20">
					<el-col :span="12">
						<el-form-item :label="$t('sharing.公司名称')" prop="company">
							<el-input v-model="editForm.company" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('sharing.分账账号')" prop="account">
							<el-input v-model="editForm.account" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="12">
						<el-form-item :label="$t('sharing.分账比例')" prop="rate">
							<el-input v-model="editForm.rate" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col> -->
					<el-col :span="12">
						<el-form-item :label="$t('sharing.是否启用')" prop="enable">
							<el-switch v-model="editForm.enable" :active-value="1" :inactive-value="0"></el-switch>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	computed: {
		editFormRules(){
			return{
				company: [{required: true, message: this.$t('index.pleaseInput'), trigger: 'blur' }],
				account: [{required: true, message: this.$t('index.pleaseInput'), trigger: 'blur' }],
				rate: [{required: true, message: this.$t('index.pleaseInput'), trigger: 'blur' }],
			}
		},
	},
	data() {
		return {
			list: [],
			editFormVisible: false,
			editForm: {},
			pages: {
				page: 1,
				count: 0,
				perpage: 10,
				date:[],
			},
			form:{},
			amount:0,
		}
	},
	// 初始事件
	mounted () {
		this.init();
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var datas = {
				page: this.pages.page,
				num: this.pages.perpage,
			};
			if(this.pages.date&&this.pages.date.length>0){
				datas['start_month'] = this.pages.date[0];
				datas['end_month'] = this.pages.date[1];
			}
			this.$post("revenueSharingList", datas).then((res) => {
				this.list = res.list;
				this.amount = res.amount;
			})
		},
		add(data) {
			if (data) {
				this.$post("revenueSharingInfo", {id:data.id}).then((res) => {
					this.editForm = res;
					this.editFormVisible = true;
				})
			} else {
				this.editForm = {
					company: '',
					account:'',
					rate:'',
					enable:0,
				}
				this.editFormVisible = true;
			}
		},
		// 保存
		editSubmit(editForm) {
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						...this.editForm
					}
					var url = "revenueSharingAction";
					var tishi = this.$t('index.add_success');
					if (this.editForm.id) {
						datas['id'] = this.editForm.id;
						tishi = this.$t('index.modify_success');
					}
					this.$post(url, datas).then((res) => {
						this.$message.success(tishi);
						this.editFormVisible = false;
						this.init();
					});
				} else {
					return false;
				}
			})
		},
		// 删除
		del(data) {
			this.$confirm(this.$t('index.confirm_delete'), this.$t('index.tips')).then(() => {
				this.$post("revenueSharingDelete", {id: data.id}).then((res) => {
					this.$message.success(this.$t('index.delete_success'));
					this.init();
				})
			}).catch(() => {});
		},
		enable_change(data){
			this.$post("revenueSharingEnable", {id: data.id,enable:data.enable}).then((res) => {
				this.$message.success(this.$t('index.modify_success'));
				this.init();
			})
		},
		// 搜索
		sousuo() {
			this.pages.page = 1;
			this.init();
		},
		// 重置
		chongxzhi() {
			this.pages.date = [];
			this.pages.page = 1;
			this.init();
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	}
}
</script>
<style scoped>
.page-pagination {
	padding: 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/sharing/index.vue